var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-standard",class:_vm.show ? '' : 'hidden',attrs:{"id":"spinner"}},[_c('div',{staticClass:"spinner-core"},[_vm._m(0),_c('div',{staticClass:"spinner-loader-text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingio-spinner-eclipse-nq4q5u6dq7r"},[_c('div',{staticClass:"ldio-x2uulkbinc"},[_c('div')])])
}]

export { render, staticRenderFns }